import { env } from "../config/env";
import { apiRequestBase, unwrapResponse } from "./client";

export interface LocationOption {
  id: number;
  name: string;
}

export const locationApi = {
  getChildren: async (
    locationTypeId: number,
    parentId?: number | null
  ): Promise<LocationOption[]> => {
    const query =
      parentId == null
        ? `/AddressLocation/GetAllChild?LocationTypeId=${locationTypeId}`
        : `/AddressLocation/GetAllChild?LocationTypeId=${locationTypeId}&parentId=${parentId}`;

    const response = await apiRequestBase<any>(env.sharedConfigBaseUrl, query, {
      method: "GET",
    });
    const result = unwrapResponse<any>(response);
    const list = Array.isArray(result) ? result : Array.isArray(result?.data) ? result.data : [];
    return list
      .map((item: any) => ({
        id: Number(item?.id),
        name: String(item?.name ?? ""),
      }))
      .filter((item: LocationOption) => Number.isFinite(item.id) && item.id > 0 && item.name);
  },
};
